<template>
  <div>
    <label class="mb-3">
      {{ index }}.
      {{ question }}
    </label>
    <b-link v-if="questionPlan" class="d-flex mb-3" @click="showModal">
      <i class="material-icons align-self-center small mx-1">
        flag
      </i>
      Click to see your plan
    </b-link>
    <table class="mb-2">
      <tr>
        <th>{{ column_1 }}</th>
        <th>{{ column_2 }}</th>
      </tr>
      <tr v-for="(item, idx) in tableRows" :key="idx">
        <td>
          <b-form-input
            @input="handleChangeElement({ id, value: tableRows })"
            v-model="item.column1"
            placeholder=""
            required
          ></b-form-input>
        </td>
        <td>
          <b-form-input
            @input="handleChangeElement({ id, value: tableRows })"
            v-model="item.column2"
            placeholder=""
            required
          ></b-form-input>
        </td>
        <td>
          <b-link @click="removeItem(idx)">
            <span class="material-icons align-middle text-danger">
              remove_circle
            </span>
          </b-link>
        </td>
      </tr>
    </table>

    <div class="mb-3 d-flex justify-content-start">
      <b-link @click="addItem()">
        Add field
      </b-link>
    </div>

    <modal :Gid="id" :planAnswers="getRelatedPlanAnswers" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import mixinListenerChangeElement from '@/mixins/listenerChangeElement';
import modal from '@/components/practice/modalQuestionPlan.vue';

export default {
  components: {
    modal,
  },
  props: {
    question: String,
    index: Number,
    id: Number,
    column_1: String,
    column_2: String,
    answers: Array,
    questionPlan: Number,
  },
  computed: {
    ...mapGetters('planning', ['getRelatedPlanAnswers']),
    ...mapGetters('user', ['getUserId']),
  },
  data() {
    return {
      tableRows: [
        {
          id: 1,
          column1: null,
          column2: null,
        },
        {
          id: 2,
          column1: null,
          column2: null,
        },
      ],
      counter: 2,
      modalQuestion: false,
    };
  },
  mixins: [mixinListenerChangeElement],
  methods: {
    ...mapActions('planning', ['FetchRelatedPlanAnswers']),
    addItem() {
      this.counter++;
      this.tableRows.push({
        id: this.counter,
        column1: null,
        column2: null,
      });
    },
    removeItem(id) {
      this.tableRows.splice(id, 1);
    },
    showModal() {
      this.FetchRelatedPlanAnswers({
        parent: this.getUserId,
        questions: [this.questionPlan],
      }).then(() => {
        this.modalQuestion = true;
      });
    },
  },
  mounted() {
    if (this.answers != null && this.answers.length != 0) {
      this.tableRows = [];
      this.answers.forEach((element) => {
        this.tableRows.push({
          id: element.id,
          column1: element.answer_text_1,
          column2: element.answer_text_2,
        });
      });
    }
  },
};
</script>
